(() => {
  const labels = document.body.dataset;
  const groups = new Map();
  const parsed = new WeakSet();
  // Storefront state per handle from data-pe-live (1 = on the Online Store and available, 0 = sold out or 404).
  // The Grouptify data can be stale, so a size is only linked once the storefront confirms it.
  const live = new Map();
  const checking = new Map();
  const checkHandles = handles => Promise.all(handles.map(handle => {
    if (!checking.has(handle)) {
      checking.set(handle, fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(response => response.ok ? response.json().then(data => live.set(handle, data && data.available ? 1 : 0)) : live.set(handle, 0))
        .catch(() => live.set(handle, 0)));
    }
    return checking.get(handle);
  }));
  let optionControlCount = 0;
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.getAttribute('action')?.split('?')[0].endsWith('/search')) return;
    let option = form.querySelector('input[name="options[unavailable_products]"]');
    if (!option) {
      option = document.createElement('input');
      option.type = 'hidden';
      option.name = 'options[unavailable_products]';
      form.append(option);
    }
    option.value = 'hide';
  }, true);
  const enhance = () => {
    for (const source of document.querySelectorAll('script[data-pe-groups]')) {
      if (parsed.has(source)) continue;
      parsed.add(source);
      try {
        for (const group of JSON.parse(source.textContent)) {
          if (!group.is_active) continue;
          for (const product of group.products || []) groups.set(String(product.id), group);
        }
      } catch (error) {
        console.warn('Fragrance options could not be loaded. Product purchase remains available.');
      }
    }
    for (const source of document.querySelectorAll('script[data-pe-live]')) {
      if (parsed.has(source)) continue;
      parsed.add(source);
      try {
        for (const [handle, state] of Object.entries(JSON.parse(source.textContent))) if (!live.has(handle)) live.set(handle, state);
      } catch (error) {}
    }
    for (const target of document.querySelectorAll('.pe-group-links[data-pe-product]')) {
      const group = groups.get(target.dataset.peProduct);
      const card = target.dataset.peContext === 'card';
      if (!group || target.dataset.peGroup === group.id || (card ? !group.show_on_card : !group.show_on_prod)) continue;
      const current = target.dataset.peProduct;
      // -1 = not confirmed yet (only possible when the stale group data still claims it is active and available)
      const stateOf = product => live.has(product.handle) ? live.get(product.handle) : (product.status === 'ACTIVE' && product.available ? -1 : 0);
      const valid = group.products.filter(product => product.id && product.handle);
      const products = valid.filter(product => String(product.id) === current || stateOf(product) === 1);
      const pending = valid.filter(product => String(product.id) !== current && stateOf(product) === -1).map(product => product.handle);
      if (pending.length && !card) {
        // Product page: confirm the other sizes before showing the selector (normally 0 requests; the server checks them).
        checkHandles(pending).then(enhance);
        continue;
      }
      if (products.length + pending.length < 2) {
        if (target.dataset.peGroup) { target.replaceChildren(); delete target.dataset.peGroup; }
        continue;
      }
      const isAvailable = product => stateOf(product) === 1;
      target.replaceChildren();
      target.dataset.peGroup = group.id;
      const links = document.createElement('nav');
      const select = document.createElement('select');
      select.className = 'pe-group-links__select';
      select.setAttribute('aria-label', labels.peGroupLabel);
      links.className = 'pe-group-links__choices';
      links.setAttribute('aria-label', labels.peGroupLabel);
      for (const product of products) {
        const link = document.createElement('a');
        const name = group.options.flatMap(option => option.values.filter(value => product.options?.includes(value.id)).map(value => value.name)).join(' · ') || product.title;
        link.href = '/products/' + encodeURIComponent(product.handle);
        link.textContent = name + (isAvailable(product) ? '' : ' · ' + labels.peSoldOut);
        const option = document.createElement('option');
        option.value = link.getAttribute('href');
        option.textContent = link.textContent;
        option.selected = String(product.id) === target.dataset.peProduct;
        select.append(option);
        const selected = String(product.id) === target.dataset.peProduct;
        if (selected) link.setAttribute('aria-current', 'page');
        if (!card) {
          const optionName = document.createElement('span');
          optionName.className = 'pe-group-links__option-name';
          optionName.textContent = name;
          const state = document.createElement('span');
          state.className = 'pe-group-links__state';
          const icon = document.createElement('span');
          icon.setAttribute('aria-hidden', 'true');
          icon.textContent = selected ? '✓' : '→';
          const stateLabel = document.createElement('span');
          stateLabel.textContent = selected ? labels.peSelectedLabel : labels.peSelectOptionLabel;
          state.append(icon, stateLabel);
          link.replaceChildren(optionName, state);
        }
        if (!isAvailable(product)) link.classList.add('pe-group-links__sold-out');
        links.append(link);
      }
      if (card) {
        const details = document.createElement('details');
        details.className = 'pe-card-options';
        const summary = document.createElement('summary');
        summary.textContent = labels.peOptionsLabel;
        details.append(summary, links);
        target.append(details);
        if (pending.length) {
          // Card: sizes from other pages are confirmed only when the shopper opens the options (no extra requests on load).
          details.addEventListener('toggle', () => {
            if (!details.open) return;
            checkHandles(pending).then(() => {
              delete target.dataset.peGroup;
              enhance();
              const next = target.querySelector('details');
              if (next) next.open = true;
            });
          }, { once: true });
        }
      } else {
        const heading = document.createElement('p');
        heading.className = 'pe-group-links__label';
        heading.textContent = labels.peChooseLabel;
        heading.id = 'pe-group-label-' + (++optionControlCount);
        const hint = document.createElement('p');
        hint.className = 'pe-group-links__hint';
        hint.textContent = labels.peOptionsHint;
        hint.id = heading.id + '-hint';
        select.setAttribute('aria-labelledby', heading.id);
        select.setAttribute('aria-describedby', hint.id);
        links.setAttribute('aria-labelledby', heading.id);
        links.setAttribute('aria-describedby', hint.id);
        select.addEventListener('change', () => window.location.assign(select.value));
        target.append(heading, hint, select, links);
      }
    }
  };
  enhance();
  const main = document.querySelector('main');
  if (!main) return;
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; enhance(); });
  });
  observer.observe(main, { childList: true, subtree: true });
})();

// Reuse the merchant's page content so future brand edits keep this layout.
(() => {
  const arrangeBrands = () => {
    const source = document.querySelector('.pe-brands-directory:not([data-pe-brands-enhanced])');
    if (!source) return;
    const groups = [];
    let current;
    for (const node of [...source.children]) {
      const text = node.textContent.trim();
      if (/^[A-Z]$/.test(text) && !node.querySelector('a')) {
        current = { letter: text, nodes: [] };
        groups.push(current);
      } else if (current && node.querySelector('a[href]')) {
        current.nodes.push(node);
      }
    }
    if (!groups.length) return;
    const fragment = document.createDocumentFragment();
    for (const group of groups) {
      const section = document.createElement('section');
      section.className = 'pe-brands-group';
      const heading = document.createElement('h2');
      heading.id = 'pe-brand-letter-' + group.letter;
      heading.textContent = group.letter;
      section.setAttribute('aria-labelledby', heading.id);
      const list = document.createElement('ul');
      for (const node of group.nodes) {
        for (const anchor of node.querySelectorAll('a')) {
          if (!anchor.textContent.trim() && !anchor.querySelector('img,svg')) anchor.remove();
        }
        const item = document.createElement('li');
        item.append(node);
        list.append(item);
      }
      section.append(heading, list);
      fragment.append(section);
    }
    source.replaceChildren(fragment);
    source.setAttribute('data-pe-brands-enhanced', '');
  };
  arrangeBrands();
  document.addEventListener('shopify:section:load', arrangeBrands);
})();

/* PE Oct 19 2026: Trustpilot product widgets reserve their full height (reviews list 700px, mini 25px) even when the
   product has no reviews, which left a blank white gap plus a grey 700px band on product pages. Ask Trustpilot's public
   widget data endpoint (the same one the widget uses) how many reviews the SKU has; if none, collapse that product's
   Trustpilot blocks and an Apps section left empty. Widgets with reviews, and the review JSON-LD, are untouched. */
(() => {
  if (window.Shopify && Shopify.designMode) return;
  const widgets = [...document.querySelectorAll('.trustpilot-widget[data-sku][data-businessunit-id]')];
  if (!widgets.length) return;
  const bySku = new Map();
  for (const widget of widgets) {
    const key = widget.dataset.businessunitId + '|' + widget.dataset.sku;
    if (!bySku.has(key)) bySku.set(key, []);
    bySku.get(key).push(widget);
  }
  const count = summary => (summary && summary.numberOfReviews && summary.numberOfReviews.total) || 0;
  bySku.forEach((group, key) => {
    const [unit, sku] = key.split('|');
    const url = 'https://widget.trustpilot.com/trustbox-data/5763bccae0a06d08e809ecbb?businessUnitId=' + encodeURIComponent(unit)
      + '&locale=en-US&sku=' + encodeURIComponent(sku) + '&reviewsPerPage=1';
    fetch(url).then(response => (response.ok ? response.json() : null)).then(data => {
      if (!data || !('productReviewsSummary' in data)) return;
      if (count(data.productReviewsSummary) + count(data.importedProductReviewsSummary) > 0) return;
      for (const widget of group) {
        const block = widget.closest('.shopify-app-block') || widget;
        block.style.display = 'none';
        block.setAttribute('data-pe-tp-empty', '');
        const section = block.closest('.shopify-section--apps');
        if (section && ![...section.querySelectorAll('.shopify-app-block')].some(item => item.style.display !== 'none')) {
          section.style.display = 'none';
        }
      }
    }).catch(() => {});
  });
})();
